import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { IoMdCloseCircle } from "react-icons/io";

export const PopupDialog = ({
  name = "",
  open = false,
  onClose = () => {},
  title = "",
  content = null,
  positiveAction = null,
  negativeAction = null,
}) => {
  const inputProps = {
    name,
    open,
    onClose,
  };

  return (
    <Dialog
      {...inputProps}
      maxWidth="xl"
      fullWidth={true}
      className="dialog-container"
    >
      <DialogTitle>
        <IoMdCloseCircle onClick={onClose} className="close" />
        {title && (
          <div>
            <label className="dialog-title">{title}</label>
            <hr />
          </div>
        )}
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        {positiveAction}
        {negativeAction}
      </DialogActions>
    </Dialog>
  );
};

PopupDialog.propTypes = {
  name: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.element,
  positiveAction: PropTypes.element,
  negativeAction: PropTypes.element,
};
